import {
  Provider,
  SideNavigation,
  SideNavigationHeader,
} from '@project44/manifest-ds';

import { Movement } from '../../icons';
import { theme } from '../../theme';

export function Skeleton() {
  return (
    <Provider css={{ height: '100%' }} className={theme.className}>
      <SideNavigation
        data-testid="side-nav-container-skeleton"
        css={{ height: '100%', width: 56 }}
      >
        <SideNavigationHeader logo={<Movement />} />
      </SideNavigation>
    </Provider>
  );
}
